import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Card, Grid, Button, Input, Dropdown, Radio, Tab} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {ordersStatus} from '../../../common/dictionaries/accessories';
import {Actions} from '../../../common/actions';
import {downloadFile} from '../../../common/util/file';

const {
  changeDevicesOrdersDate,
  changeDevicesOrdersDateEnd,
  fetchDevicesOrdersList,
  cleanDevicesOrderList,
  generateAndInstallDeviceOrders,
  downloadOrdersList,
} = Actions;

const panes = [
  {'menuItem': 'Creación'},
  {'menuItem': 'Anuladas'},
];

const TAB_CREATE_ORDERS = 0;


const PrintButton = ({buttonStatus, date, ordersMarked, type, orderStatusSelected}) => {
  function handlePrintClick() {
    const status = orderStatusSelected === 'ALL' ? '' : `&status=${orderStatusSelected}`;
    const dateFormatted = date ? moment(date).format(noTimeZoneShortISODate) : '';
    const baseUrl = process.env.REP_API_URL;
    const queryString = `date=${dateFormatted}&type=hunter${status}&orders=${ordersMarked.join(',')}`;
    const fileUrl = `${baseUrl}/accessories/orders/documents?${queryString}`;
    downloadFile(fileUrl);
  }

  if (!ordersMarked.length) {
    return null;
  }

  return (
    <Button primary disabled={buttonStatus} onClick={handlePrintClick}>Imprimir</Button>
  );
};

const getOrderStatusOptions = (orderStatusList) => {
  const options = orderStatusList.map((item) => {
    return {'text': item.description, 'value': item.id};
  });
  options.unshift({'text': 'TODOS', 'value': 'ALL'});
  return options;
};

const Header = ({type, devicesOrders, changeSelectedFiltersState, orderStatusList,
  activeTabIndex, changeTab}) => {
  const dispatch = useDispatch();
  const {searchDate, loading, creating, downloading, cancelling,
    loadingStatus, ordersMarked, chassisMarked, list} = devicesOrders;
  
  const [ordersState, setOrdersState] = useState({
    'orderStatusSelected': 'ALL',
    'chassisFilter': '',
    'invoicingTypeSelected': 'N',
    'invoicingTypeLabel': 'NORMAL',
    'dateSelected': '',
    'dateEndSelected': '',
    'order': '',
  });

  useEffect(() => {
    setOrdersState({...ordersState,
      'dateSelected': ordersState.dateSelected ? ordersState.dateSelected : '',
      'dateEndSelected': ordersState.dateEndSelected ? ordersState.dateEndSelected : '',
    });
  }, []);

  const buttonStatus = (!ordersState.dateSelected && !ordersState.chassisFilter && !ordersState.order) ||
    loading || creating || downloading || cancelling;

  const handleSearchClick = () => {
    if (!ordersState.dateSelected && !ordersState.chassisFilter && !ordersState.order) {
      dispatch(cleanDevicesOrderList());
      return;
    }
  
    const params = {
      type,
      'date': ordersState.dateSelected,
      'dateEnd': ordersState.dateEndSelected,
      'order': ordersState.order,
      'chassis': ordersState.chassisFilter,
      'status': ordersState.orderStatusSelected === 'ALL' ? '' : ordersState.orderStatusSelected,
      'invoiceType': ordersState.invoicingTypeSelected,
    };
    dispatch(fetchDevicesOrdersList(params));
  };

  const handleGenerateOrdersClick = () => {
    const params = chassisMarked.filter((x) => list.find((y) => y.chassis === x && !y.order));
    const filterState = {
      type,
      'date': ordersState.dateSelected,
      'dateEnd': ordersState.dateEndSelected,
      'order': ordersState.order,
      'chassis': ordersState.chassisFilter,
      'status': ordersState.orderStatusSelected === 'ALL' ? '' : ordersState.orderStatusSelected,
      'invoiceType': ordersState.invoicingTypeSelected,
    };
    dispatch(generateAndInstallDeviceOrders({'chassisList': params}, filterState));
  };

  const changeFiltersState = () => {
    changeSelectedFiltersState(ordersState.dateSelected, ordersState.dateEndSelected, ordersState.chassisFilter,
      ordersState.orderStatusSelected, ordersState.invoicingTypeSelected);
    handleSearchClick();
  };

  const onTabChange = (event, data) => {
    if (activeTabIndex === data.activeIndex) {
      return;
    }
    
    const newStatusSelected = data.activeIndex === TAB_CREATE_ORDERS ? 'ALL' : ordersStatus.canceled_order;
    const newInvoiceTypeSelected = data.activeIndex !== TAB_CREATE_ORDERS ? 'N' : ordersState.invoicingTypeSelected;
    const newInvoiceTypeLabel = data.activeIndex !== TAB_CREATE_ORDERS ? 'NORMAL' : ordersState.invoicingTypeLabel;
    const newDateSelected = ordersState.dateSelected ? ordersState.dateSelected : '';
    
    setOrdersState({...ordersState,
      'orderStatusSelected': newStatusSelected,
      'invoicingTypeSelected': newInvoiceTypeSelected,
      'invoicingTypeLabel': newInvoiceTypeLabel,
      'dateSelected': newDateSelected,
    });
    changeTab(data.activeIndex);
  };

  useEffect(() => {
    changeFiltersState();
  }, [ordersState]);

  const handleDateChange = (date, dateType) => {
    console.log(date);
    console.log(dateType);
    const dateFormatted = date ? moment(date).format(noTimeZoneShortISODate) : '';
    if (dateType === 'start') {
      dispatch(changeDevicesOrdersDate(dateFormatted));
      setOrdersState({...ordersState, 'dateSelected': dateFormatted});
    } else {
      dispatch(changeDevicesOrdersDateEnd(dateFormatted));
      setOrdersState({...ordersState, 'dateEndSelected': dateFormatted});
    }
  };

  const onChangeValues = (value, field) => {
    const newValue = value.toUpperCase();

    if (field === 'chassisFilter') {
      setOrdersState({...ordersState, 'chassisFilter': newValue});
    } else if (field === 'orderStatusSelected') {
      setOrdersState({...ordersState, 'orderStatusSelected': newValue});
    } else if (field === 'orderFilter') {
      setOrdersState({...ordersState, 'order': newValue});
    }
  };

  const onChangeToggle = (value) => {
    if (value) {
      setOrdersState({...ordersState,
        'invoicingTypeSelected': 'S',
        'invoicingTypeLabel': 'ANTICIPADA',
      });
    } else {
      setOrdersState({...ordersState,
        'invoicingTypeSelected': 'N',
        'invoicingTypeLabel': 'NORMAL',
      });
    }
  };

  const exportDevicesOrdersList = (e) => {
    e.preventDefault();
    const filterState = {
      type,
      'date': ordersState.dateSelected,
      'dateEnd': ordersState.dateEndSelected,
      'order': ordersState.order,
      'chassis': ordersState.chassisFilter,
      'status': ordersState.orderStatusSelected === 'ALL' ? '' : ordersState.orderStatusSelected,
      'invoiceType': ordersState.invoicingTypeSelected,
    };
    dispatch(downloadOrdersList(filterState));
  };

  return (
    <Card raised fluid>
      <div className='navigation-section'>
        <Tab
          menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
          panes={panes}
          activeIndex={activeTabIndex}
          onTabChange={onTabChange}
        />
      </div>

      <div className='title-bar'>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <div className='title'>
                <h2>Órdenes de Dispositivos
                  {activeTabIndex !== TAB_CREATE_ORDERS ? ' Anuladas' : ''}
                </h2>
              </div>
            </Grid.Column>
            <Grid.Column textAlign='right' width={8} className='flex end'>
              <Button secondary size='small' className='add-btns-pading' compact disabled={buttonStatus}
                onClick={(e) => exportDevicesOrdersList(e)}>
                <img src={`${process.env.PUBLIC_URL}/icons/excel.svg`} alt='excel icon' width={25} />
              </Button>
              <Button primary disabled={buttonStatus}
                onClick={handleSearchClick}>Buscar</Button>
              <Button primary disabled={loading || chassisMarked.length === 0}
                onClick={handleGenerateOrdersClick}>Instalar</Button>
              <PrintButton
                buttonStatus={buttonStatus}
                date={searchDate}
                type={type}
                ordersMarked={ordersMarked}
                orderStatusSelected={ordersState.orderStatusSelected} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <div className='filters-section'>
          <Grid padded='horizontally'>
            <Grid.Row textAlign='left'>
              <Grid.Column mobile={8} tablet={4} computer={3} largeScreen={2}>
                <h4 style={{'margin': '1rem 0 0 0'}}>Fecha inicio:</h4>
                <DatePicker
                  locale='es'
                  dateFormat={dateFormatPicker}
                  disabled={loadingStatus || downloading}
                  customInput={<Input readOnly icon='calendar' size='small' />}
                  selected={ordersState.dateSelected ?
                    moment(ordersState.dateSelected, noTimeZoneShortISODate).toDate() : null}
                  onChange={(date) => handleDateChange(date, 'start')}
                />
              </Grid.Column>
              <Grid.Column mobile={8} tablet={4} computer={3} largeScreen={2}>
                <h4 style={{'margin': '1rem 0 0 0'}}>Fecha fin:</h4>
                <DatePicker locale='es' todayButton="Hoy" customInput={<Input readOnly icon='calendar' size='small' />}
                  dateFormat={dateFormatPicker} disabled={loadingStatus || downloading}
                  minDate={ordersState.dateSelected ?
                    moment(ordersState.dateSelected, noTimeZoneShortISODate).toDate() : null}
                  selected={ordersState.dateEndSelected ?
                    moment(ordersState.dateEndSelected, noTimeZoneShortISODate).toDate() : null}
                  onChange={(dateEnd) => handleDateChange(dateEnd, 'end')}
                />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={8} computer={6} largeScreen={4}>
                <h4 style={{'margin': '1rem 0 0 0'}}>Chasis:</h4>
                <Input
                  value={ordersState.chassisFilter}
                  disabled={loadingStatus || downloading}
                  onChange={(e, {value}) => onChangeValues(value, 'chassisFilter')}
                  placeholder='Chasis'
                />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={6} computer={4} largeScreen={3}>
                <h4 style={{'margin': '1rem 0 0 0'}}>Nº Orden:</h4>
                <Input
                  value={ordersState.order}
                  disabled={loadingStatus || downloading}
                  onChange={(e, {value}) => onChangeValues(value, 'orderFilter')}
                  placeholder='Orden'
                />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={6} computer={6} largeScreen={3}>
                <h4 style={{'margin': '1rem 0 0 0'}}>Estado:</h4>
                <Dropdown selection
                  options={getOrderStatusOptions(orderStatusList)}
                  search
                  name='status-container'
                  value={ordersState.orderStatusSelected}
                  disabled={loadingStatus || downloading}
                  loading={loadingStatus}
                  onChange={(e, {value}) => onChangeValues(value, 'orderStatusSelected')}
                  placeholder='Seleccione Estado'
                  noResultsMessage='Estado no encontrado'
                />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={2} computer={10} largeScreen={2}>
                {<h4 style={{'margin': '1rem 0 0 0'}}>Facturación:</h4>}
                {<Radio toggle checked={ordersState.invoicingTypeSelected === 'S'}
                  label={ordersState.invoicingTypeLabel}
                  style={{'minHeight': '2.5rem'}} className='flex middle'
                  onChange={(e, {checked}) => onChangeToggle(checked)} />
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    </Card>
  );
};

export default Header;
